import { render } from "./minimalRoomList.vue?vue&type=template&id=6ac15f15&ts=true"
import script from "./minimalRoomList.ts?vue&type=script&lang=ts"
export * from "./minimalRoomList.ts?vue&type=script&lang=ts"

import "./minimalRoomList.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__